/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2019. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-complete-profile-modal',
  templateUrl: './complete-profile-modal.component.html',
  styleUrls: ['./complete-profile-modal.component.scss'],
})
export class CompleteProfileModalComponent implements OnInit {
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter();

  currentIndex = 0;
  pages = [
    {
      image: 'profile',
      title: `Try our new recruiting profile`,
      message: `Use our new shareable recruiting profile to promote yourself to college coaches. It’s the best way to share your highlight reels and clips!`,
    },
    {
      image: 'athletic-info',
      title: `Add your key information`,
      message: `There’s a place for all your detailed athletic info. Add clubs, stats, honors and awards and more to strengthen your profile.`,
    },
    {
      image: 'highlight-reels',
      title: `Select your highlight reels`,
      message: `Add your existing highlight reels or have NextPro professionals create one for you.`,
    },
    {
      image: 'clips',
      title: `Pick your best clips`,
      message: `Pick your best clips to display on your profile.`,
    },
    {
      image: 'profile-share',
      title: `Share your profile`,
      message: `That’s it - you now have an awesome profile you can share with coaches and friends!`,
    },
  ];

  constructor() {}

  ngOnInit() {}

  close() {
    this.closeModal.emit();
  }

  selectPrevious() {
    this.currentIndex--;
  }
  selectNext() {
    this.currentIndex++;
  }
}
